module.exports = __webpack_public_path__ + "media/mainsong.a9aba73f.mp3";